<div class="window">
    @if (pageFooterSummary) {
        <div class="window-summary" id="summary">
            <ng-container [ngTemplateOutlet]="pageFooterSummary"></ng-container>
        </div>
    }
    <div class="window-main">
        @if (pageFooterControls) {
            <div class="window-main-controls" id="controls">
                <ng-container [ngTemplateOutlet]="pageFooterControls"></ng-container>
            </div>
        }
        <div class="window-main-buttons" id="buttons">
            <ng-container [ngTemplateOutlet]="pageFooterButtons"></ng-container>
        </div>
    </div>
</div>
